var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"license-image-card-item"},[_c('p',{staticClass:"license-image-card-item_title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',[_vm._v(_vm._s(_vm.textContent))])])
}
var staticRenderFns = []

export { render, staticRenderFns }